export default __webpack_public_path__ + "static/media/github_icon.bf85ce05.png";